import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { PharmacyTypes } from "@/types";

export interface PharmacyGetState {
  pharmacy: {
    details: PharmacyTypes.Pharmacy;
  };
}

const DEFAULT_PHARMACY_GET_STATE: PharmacyGetState = {
  pharmacy: {
    details: {
      provider_id: "",
      npi: "",
      name: "",
      address_line_1: "",
      address_line_2: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      hours: [],
      is_24_hours: "",
      languages: [],
      latitude: "",
      longitude: "",
      network_status: "",
      services: {
        accepts_eprescriptions_indicator: "",
        closed_door_facility_indicator: "",
        compounding_service_indicator: "",
        delivery_service_indicator: "",
        drive_up_window_indicator: "",
        durable_medical_equipment_indicator: "",
        handicapped_accessible_indicator: "",
        immunizations_provided_indicator: "",
        multi_dose_compliance_packaging_indicator: "",
        walk_in_clinic_indicator: "",
        _24_hour_emergency_service_indicator: "",
        _340b_status_indicator: "",
      },
    },
  },
};

export default (state: PharmacyGetState = DEFAULT_PHARMACY_GET_STATE, action: Action): {} => {
  if (action.type === ActionTypes.GET_PHARMACY_RESULTS) {
    return {
      ...state,
      pharmacy: {
        ...state.pharmacy,
        details: action.payload,
      },
    };
  } else {
    return state;
  }
};
